import { render, staticRenderFns } from "./LayoutGridInner.vue?vue&type=template&id=70e4e860&"
import script from "./LayoutGridInner.vue?vue&type=script&lang=js&"
export * from "./LayoutGridInner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports